interface Props {
    message?: string;
}

export function EmpresaNotFound({ message }: Props) {
    return (
        <div className="flex justify-center h-full w-full p-3">
            <div>
                <p className="text-center font-semibold text-4xl">404</p>
                <p className="text-center font-semibold text-2xl">Empresa no encontrada</p>
                <p>{message}</p>
            </div>
        </div>
    );
} 